import FormTambahCuti from "../../../Cuti/components/FormTambahCuti";
import { FormModal } from "../../../../CommonElements";
import QuickOptionButton from "./QuickOptionButton";
import { useEffect, useState } from "react";
import { Calendar } from "react-feather";
import { useAbsensi } from "../../../../Context/AbsensiContext";
import { useCuti } from "../../../../Context/CutiContext";

const AjukanCuti = () => {
  const absensiAPI = useAbsensi()
  const cutiAPI = useCuti()
  const [isOpen, setIsOpen] = useState(false);
  const [tipeAbsensi, setTipeAbsensi] = useState([]);
  const toggle = () => setIsOpen(!isOpen);

  const staf_id = localStorage.getItem("staf_id")
  const name = localStorage.getItem("name")
  const data = [{
    id: parseInt(staf_id),
    nama: name
  }]

  useEffect(() => {
    if (isOpen) {
      refreshTipeAbsensi();
    }
  }, [isOpen]);

  const refreshTipeAbsensi = () => {
    absensiAPI.getTipeAbsensi().then((res) => {
      setTipeAbsensi(res.data);
    });
  };

  return (
    <>
      <QuickOptionButton
        title="Ajukan Cuti"
        icon={<Calendar />}
        onClick={toggle}
      />
      <FormModal title={"Ajukan Cuti"} isOpen={isOpen} toggle={toggle}>
        <FormTambahCuti
          resetState={cutiAPI.getCuti}
          toggle={toggle}
          tipeAbsensi={tipeAbsensi}
          staf={data}
          create={true}
        />
      </FormModal>
    </>
  );
};

export default AjukanCuti;
